var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor reservation-event-list" }, [
    _c("div", { staticClass: "reservation-event-list-wrapper" }, [
      _c("div", { staticClass: "inputTitle" }, [
        _vm._v("Kullanıcı email adresi"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              "show-attributes": true,
              "max-character-count": 64,
              "show-emoji": false,
              rows: 1,
            },
            model: {
              value: _vm.clone.visitorEmail,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "visitorEmail", $$v)
              },
              expression: "clone.visitorEmail",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }